export default "__VITE_ASSET__a8aface2__"